import { useQuery } from '@tanstack/react-query';

import getOneRoleAccess from 'Api/role/getOneRoleAccess';

import getOneRoleAccessResponse from './model/response/getOneRoleAccessResponse';

const useGetOneRoleAccess = (id) =>
  useQuery({
    queryKey: ['roles', id],
    queryFn: async () => {
      const response = await getOneRoleAccess(id);

      const result = getOneRoleAccessResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: id !== undefined,
  });

export default useGetOneRoleAccess;
